// Claves de Session Storage
const SCROLL_POS_KEY = 'SCROLL_POS_PRODUCT';
const PRODUCT_HANDLE_KEY = 'LAST_VIEWED_HANDLE';

/**
 * 1. Guarda el estado del producto al hacer clic.
 */
function saveProductState(event) {
    const clickedItem = event.target.closest('.grid__item');
    
    if (!clickedItem) {
        return;
    }

    const cardWrapper = clickedItem.querySelector('.card-wrapper');
    
    // Guardar posición actual y handle
    localStorage.setItem(SCROLL_POS_KEY, window.scrollY.toString());

    if (cardWrapper && cardWrapper.dataset.handle) {
        localStorage.setItem(PRODUCT_HANDLE_KEY, cardWrapper.dataset.handle);
        console.log(`Estado guardado. Handle: ${cardWrapper.dataset.handle} | Pos: ${window.scrollY}`);
    } else {
        localStorage.removeItem(PRODUCT_HANDLE_KEY);
        console.warn('Advertencia: El elemento clicado no tiene data-handle.');
    }
}

/**
 * 2. Intenta restaurar la posición al volver a la página.
 */
function restorePositionScroll() {
    const savedHandle = localStorage.getItem(PRODUCT_HANDLE_KEY);
    const savedScrollPos = localStorage.getItem(SCROLL_POS_KEY);

    if (savedHandle) {
        console.log(`Buscando producto con handle: ${savedHandle}`);
        let targetElement = document.querySelector(`[data-handle="${savedHandle}"]`);
        
        if (targetElement) {
            // Caso 1: Producto está en carga inicial
            console.log('Producto encontrado en carga inicial');
            scrollToElementWithOffset(targetElement);
            cleanupStorage();
        } else {
            // Caso 2: Producto NO está - cargar dinámicamente
            console.log(`Producto no encontrado. Iniciando carga dinámica...`);
            attemptLoadAndScroll(savedHandle);
        }
    } else if (savedScrollPos) {
        // Caso de respaldo
        window.scrollTo(0, parseInt(savedScrollPos, 10));
        console.log(`Scroll restaurado a posición general: ${savedScrollPos}px`);
        cleanupStorage();
    }
}

/**
 * Calcula la altura total de las barras fijas superiores.
 */
function getFixedOffsetHeight() {
    const announcementBar = document.querySelector('.announcement-custom-section');
    const header = document.querySelector('.shopify-section-header-sticky');
    
    let totalHeight = 0;

    if (announcementBar) {
        totalHeight += announcementBar.offsetHeight; 
    }
    if (header) {
        totalHeight += header.offsetHeight;
    }
    
    return totalHeight; 
}

function scrollToElementWithOffset(targetElement) {
    const offset = getFixedOffsetHeight();
    const absoluteElementTop = window.scrollY + targetElement.getBoundingClientRect().top;
    const scrollPosition = Math.max(0, absoluteElementTop - offset - 20); // Pequeño margen
    
    console.log(`Scroll to element - Offset: ${offset}, Target position: ${scrollPosition}`);
    
    window.scrollTo({ 
        top: scrollPosition,
        behavior: 'auto'
    }); 
}

/**
 * Estrategias mejoradas para activar carga infinita
 */
function triggerInfiniteLoad() {
    console.log('Activando estrategias de carga infinita...');
    
    // Estrategia 1: Scroll hasta el fondo para activar carga
    window.scrollTo({
        top: document.documentElement.scrollHeight - window.innerHeight,
        behavior: 'auto'
    });
    
    // Estrategia 2: Disparar múltiples eventos de scroll
    setTimeout(() => {
        window.dispatchEvent(new Event('scroll'));
        window.dispatchEvent(new Event('wheel'));
    }, 100);
    
    // Estrategia 3: Buscar y hacer click en botón de "Load More" si existe
    setTimeout(() => {
        const loadMoreButton = document.querySelector('[data-load-more], .load-more, .collection__load-more, #load-more');
        if (loadMoreButton) {
            console.log('Botón Load More encontrado, haciendo click...');
            loadMoreButton.click();
        }
    }, 200);
    
    // Estrategia 4: Scroll intermedio
    setTimeout(() => {
        window.scrollTo({
            top: document.documentElement.scrollHeight / 2,
            behavior: 'auto'
        });
        window.dispatchEvent(new Event('scroll'));
    }, 300);
}

/**
 * 3. Bucle de espera y carga forzada - MEJORADO
 */
function attemptLoadAndScroll(targetHandle) {
    let attempts = 0;
    const maxAttempts = 50; // Aumentamos intentos
    let foundElement = false;

    console.log(`Iniciando búsqueda del producto: ${targetHandle}`);

    const checkAndScroll = setInterval(() => {
        // Buscar el elemento
        let targetElement = document.querySelector(`[data-handle="${targetHandle}"]`);
        
        if (targetElement && !foundElement) {
            foundElement = true;
            clearInterval(checkAndScroll);
            console.log('✅ Producto encontrado después de carga dinámica');
            
            // Pequeño delay para asegurar que el DOM esté estable
            setTimeout(() => {
                scrollToElementWithOffset(targetElement);
                cleanupStorage();
                console.log('🎉 Restauración completada exitosamente');
            }, 100);
            return;
        } 
        
        attempts++;
       // console.log(`Intento ${attempts} - Producto no encontrado aún`);

        // Estrategias de activación de carga
        if (attempts <= 15) {
            // Primera fase: scroll suave
            if (attempts % 3 === 0) {
                window.dispatchEvent(new Event('scroll'));
            }
        } else if (attempts <= 30) {
            // Segunda fase: scroll más agresivo
            if (attempts % 2 === 0) {
                window.scrollTo({
                    top: window.scrollY + 500,
                    behavior: 'auto'
                });
                window.dispatchEvent(new Event('scroll'));
            }
        } else {
            // Tercera fase: estrategias completas
            if (attempts % 5 === 0) {
                triggerInfiniteLoad();
            }
        }

        // Límite de intentos
        if (attempts >= maxAttempts && !foundElement) {
            clearInterval(checkAndScroll);
            console.error('❌ Límite de intentos alcanzado. Producto no encontrado.');
            
            // Último intento desesperado
            triggerInfiniteLoad();
            
            // Buscar una última vez después de la carga final
            setTimeout(() => {
                const finalElement = document.querySelector(`[data-handle="${targetHandle}"]`);
                if (finalElement) {
                    console.log('✅ ¡Producto encontrado en último intento!');
                    scrollToElementWithOffset(finalElement);
                } else {
                    console.warn('⚠️  Restauración fallida. Mostrando parte superior de la página.');
                    window.scrollTo(0, 0);
                }
                cleanupStorage();
            }, 1000);
        }
    }, 400); // Intervalo aumentado para dar tiempo a la carga
}


/**
 * Limpieza centralizada del storage
 */
function cleanupStorage() {
    const hadHandle = localStorage.getItem(PRODUCT_HANDLE_KEY) !== null;
    const hadScroll = localStorage.getItem(SCROLL_POS_KEY) !== null;
    
    localStorage.removeItem(PRODUCT_HANDLE_KEY);
    localStorage.removeItem(SCROLL_POS_KEY);
    
    console.log('🧹 Storage limpiado', { 
        hadHandle: hadHandle, 
        hadScroll: hadScroll 
    });
}

// ----------------------------------------------------
// IMPLEMENTACIÓN DE EVENTOS
// ----------------------------------------------------

document.addEventListener('DOMContentLoaded', () => {
    const staticContainer = document.querySelector('#MainContent') || document.body;

    // Delegación de eventos para clicks en productos
    staticContainer.addEventListener('click', (event) => {
        const clickedProductItem = event.target.closest('.grid__item');
        
        if (clickedProductItem) {
            console.log('🖱️ Producto clickeado - guardando estado');
            saveProductState(event);
        }
    });

    // Restaurar posición cuando la página se carga
    window.addEventListener('pageshow', (event) => {
        console.log('🔄 Página mostrada - verificando si necesitamos restaurar scroll');
        // Pequeño delay para asegurar que el DOM esté completamente listo
        setTimeout(() => {
            if (localStorage.getItem(PRODUCT_HANDLE_KEY)) {
                restorePositionScroll();
            }
        }, 200);
    });

    // También intentar restaurar en load por si pageshow no se dispara
    window.addEventListener('load', () => {
        setTimeout(() => {
            if (localStorage.getItem(PRODUCT_HANDLE_KEY)) {
                console.log('📦 Página cargada - restaurando posición');
                restorePositionScroll();
            }
        }, 300);
    });
});